export { PARTS_INVENTORY_ADJUSTMENTS as NAME } from '../constants';
export const DMS_MODULE = 'Nd';
export const CRUMB_LABEL_KEY = 'PartsInventoryAdjustment';
export const DEPENDENT_TABLES_ALL = <const>[];
export type DependentTableNames = typeof DEPENDENT_TABLES_ALL[number];

export enum RequestStatus {
	APPROVED = 1,
	PENDING = 2,
	REJECTED = 3
}

export enum EMAIL_TYP_PZN {
	INV_ADJUST_NOTIFY = 60,
}

export const ITEM_NO = 'ITEM_NO';

export const GRID_COLUMNS = {
	ITEM_NO,
};
